<script>
  // Renders one cell for a column against a row. Resolution precedence:
  //   0. renderer + lightbox -> the renderer owns the link (its image opens the
  //      lightbox, so it can't sit inside a <Link>); gets `href` + `onImageEdit`
  //   1. renderer + link  -> <Link> wrapping the renderer
  //   2. renderer         -> the renderer component
  //   3. null value       -> em dash
  //   4. link             -> <Link> (internal) / <a> (`external: true`) with the text value
  //   5. plain text
  // Steps 4-5 add a muted second line when the column sets `subtitle` (a row key).
  //
  // Every column property naming row data (`field`, `link`, `subtitle`, …) is a key
  // (dot-path) into the row: the server serializes display-ready values and `*_url`
  // fields built with Rails route helpers, so configs never hold functions.
  import { Link } from '@inertiajs/svelte'
  import { resolveField } from '../../lib/entities/slots.js'
  import { rendererFor } from './renderers/index.js'

  let { row, column, onToggle = null, onImageEdit = null } = $props()

  const value = $derived(resolveField(row, column.field))
  const Renderer = $derived(rendererFor(column.renderer))
  const href = $derived(column.link ? resolveField(row, column.link) || null : null)
  const external = $derived(!!column.external)
  const subtitle = $derived(column.subtitle ? resolveField(row, column.subtitle) : null)
</script>

{#if Renderer && column.lightbox}
  <Renderer {value} {row} {column} {onToggle} {onImageEdit} href={external ? null : href} />
{:else if Renderer}
  {#if href && !external}
    <Link {href} class="hover:underline"><Renderer {value} {row} {column} {onToggle} /></Link>
  {:else}
    <Renderer {value} {row} {column} {onToggle} />
  {/if}
{:else if value == null || value === ''}
  <span class="text-base-content/40">—</span>
{:else if href && external}
  <a {href} target="_blank" rel="noreferrer" class="link">{value}</a>
{:else if href}
  <Link {href} class="link link-hover font-medium">{value}</Link>
  {#if subtitle}<div class="text-xs text-base-content/60">{subtitle}</div>{/if}
{:else}
  <span>{value}</span>
  {#if subtitle}<div class="text-xs text-base-content/60">{subtitle}</div>{/if}
{/if}
